import React, { useState, Fragment } from 'react';
import { FileText, ChevronDown, ChevronUp, Download } from 'lucide-react';
import { Card } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { Button } from '../components/ui/Button';
import { MOCK_HISTORY } from '../data/mockData';
export function HistoryPage() {
  const [expandedRow, setExpandedRow] = useState<string | null>(null);
  const toggleRow = (id: string) => {
    setExpandedRow(expandedRow === id ? null : id);
  };
  return <div className="p-8 max-w-7xl mx-auto space-y-8" data-id="element-143">
      <div className="flex items-center justify-between" data-id="element-144">
        <div data-id="element-145">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-146">
            Distribution History
          </h1>
          <p className="text-gray-500 mt-1" data-id="element-147">
            Audit log of all lead uploads and distributions
          </p>
        </div>
        <Button variant="outline" leftIcon={<Download className="w-4 h-4" data-id="element-149" />} data-id="element-148">
          Export Log
        </Button>
      </div>

      <Card noPadding data-id="element-150">
        <div className="overflow-x-auto" data-id="element-151">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-152">
            <thead className="bg-gray-50" data-id="element-153">
              <tr data-id="element-154">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-155">
                  Date
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-156">
                  File Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-157">
                  Total Leads
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-158">
                  Teams
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-159">
                  Status
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-160">
                  Details
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-161">
              {MOCK_HISTORY.map(history => <Fragment key={history.id} data-id="element-162">
                  <tr className={`hover:bg-gray-50 transition-colors cursor-pointer ${expandedRow === history.id ? 'bg-gray-50' : ''}`} onClick={() => toggleRow(history.id)} data-id="element-163">
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-164">
                      {new Date(history.date).toLocaleString()}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-165">
                      <div className="flex items-center" data-id="element-166">
                        <FileText className="h-4 w-4 text-gray-400 mr-2" data-id="element-167" />
                        <span className="text-sm font-medium text-gray-900" data-id="element-168">
                          {history.fileName}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 font-medium" data-id="element-169">
                      {history.totalLeads}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-170">
                      {history.teamsInvolved.length} teams
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-171">
                      <Badge variant={history.status === 'completed' ? 'success' : history.status === 'failed' ? 'error' : history.status === 'partial' ? 'warning' : 'blue'} data-id="element-172">
                        {history.status.charAt(0).toUpperCase() + history.status.slice(1)}
                      </Badge>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-173">
                      <button className="text-gray-400 hover:text-indigo-600" data-id="element-174">
                        {expandedRow === history.id ? <ChevronUp className="h-5 w-5" data-id="element-175" /> : <ChevronDown className="h-5 w-5" data-id="element-176" />}
                      </button>
                    </td>
                  </tr>

                  {expandedRow === history.id && <tr className="bg-gray-50" data-id="element-177">
                      <td colSpan={6} className="px-6 py-4" data-id="element-178">
                        <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm" data-id="element-179">
                          <h4 className="text-sm font-medium text-gray-900 mb-3" data-id="element-180">
                            Distribution Breakdown
                          </h4>
                          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-181">
                            {history.breakdown.length > 0 ? history.breakdown.map(item => <div key={item.teamId} className="flex justify-between items-center p-3 bg-gray-50 rounded border border-gray-100" data-id="element-182">
                                  <span className="text-sm text-gray-700" data-id="element-183">
                                    {item.teamName}
                                  </span>
                                  <span className="text-sm font-bold text-gray-900" data-id="element-184">
                                    {item.count} leads
                                  </span>
                                </div>) : <p className="text-sm text-gray-500 italic" data-id="element-185">
                                No distribution data available.
                              </p>}
                          </div>
                        </div>
                      </td>
                    </tr>}
                </Fragment>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}